import { useTranslation } from 'react-i18next'
import { Typography } from 'antd'
import useMutation from 'hooks/useMutation'

import Button from 'components/atoms/Button'
import Modal from 'components/atoms/Modal'

export default function DeleleFloorModal({
  handleCancel,
  type,
  buildingId,
  buildingName,
  handleReload
}: {
  handleCancel: () => void
  type: string
  buildingId: number
  buildingName: string
  handleReload: () => void
}) {
  const { t } = useTranslation()

  const { trigger, isMutating } = useMutation(`/v1/buildings/${buildingId}`)

  const handleDeleteBuilding = () => {
    if (type === 'building') {
      !isMutating &&
        trigger(
          {
            method: 'delete',
            data: null,
            successMessage: 'organization.successDeletedNotification'
          },
          {
            onSuccess: () => {
              handleReload()
              handleCancel()
            }
          }
        )
    }
  }

  return (
    <Modal width="480px" onCancel={handleCancel} isEnterable={false}>
      <div className="text-center flex flex-col gap-[40px] items-center p-[50px]">
        <div className="flex flex-col justify-center items-center">
          <Typography className="text-[20px] font-[700] theme-text-primary">
            {t(`building.delete-title`)}
          </Typography>
          <div className="border-0 border-b border-solid theme-border-primary w-10 m-auto mt-[10px] mb-[14px]" />
        </div>
        <Typography className="text-[14px] font-[400]">
          {t('building.delete-sub-title')}
        </Typography>
        <div className="bg-[#F9FBFF] w-[360px] py-[18px] rounded-[10px]">
          <Typography className="text-[16px] font-[400] ">
            {buildingName}
          </Typography>
        </div>
        <div className="flex gap-10 justify-center w-full items-end">
          <Button onClick={handleCancel} sizing="w-[140px] h-[50px]">
            {t('common.cancel')}
          </Button>
          <Button
            onClick={handleDeleteBuilding}
            sizing="w-[140px] h-[50px]"
            className="bg-[#B80808]"
          >
            {t('common.delete')}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
